import React, { Component } from "react";
import Question from '../components/Question'
import { Card, Form, Col } from 'react-bootstrap'
import { quoteStepChanged, updateDriver } from "../state/appActions";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { IAppState } from "../state/interfaces";
import { IDictionaryItem } from "../classes/Domain";
import { connect } from "react-redux";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, YES_NO } from "../AppConstants";
import { ValidatableForm } from "../components/ValidatableForm"
import Utilities from "../classes/Utilities";
import { validationUtils } from "../validation/Validation";
import QuoteStep from "./QuoteStepLayout";
import ButtonContinue from "../components/ButtonContinue";
import Suggest, { ISuggestOption } from "../components/Suggest";
import DriversApiClient from "../classes/DriversApiClient";
import QuoteStepBase from '../components/QuoteStepBase';

export const LABELS = {
    OCCUPATION: "Occupation",
    FORMER_OCCUPATION: "Former Occupation",
    MILITARY_BRANCH: "Military Branch",
    MILITARY_RANK: "Military Rank",
    FORMER_MILITARY_BRANCH: "Former Military Branch",
    FORMER_MILITARY_RANK: "Former Military Rank"
}

interface IState extends IQuoteStepState {
    education: string,
    employment: string,
    occupation: IDictionaryItem | null | undefined,
    militaryBranch: string,
    militaryRank: string,
    hasBAverageOrHigher: string,
    labelOccupation: string,
    visibleOccupation: boolean,
    visibleBAverageOrHigher: boolean,
    labelMilitaryBranch: string,
    visibleMilitaryBranch: boolean,
    labelMilitaryRank: string,
    visibleMilitaryRank: boolean;
}

class EducationEmployment extends QuoteStepBase<IDriverStepProps, IState> {
    constructor(props: IDriverStepProps) {
        super(props);

        this.next = this.next.bind(this);

        this.state = {
            education: "",
            employment: "",
            occupation: null,
            hasBAverageOrHigher: "",
            militaryBranch: "",
            militaryRank: "",
            labelOccupation: "",
            visibleOccupation: false,
            visibleBAverageOrHigher: false,
            labelMilitaryBranch: "",
            visibleMilitaryBranch: false,
            labelMilitaryRank: "",
            visibleMilitaryRank: false,
            updatingStore: false,
            errors : null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    setStateValue(value: any, property: string) {
        const obj = {};
        obj[property] = value;
        this.setState({ ...this.state, ...obj });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;

            const visibleMilitary = driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.MILITARY ||
                driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY;

            const occupation = driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.OTHER ||
                driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.EMPLOYED ||
                driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.SELF_EMPLOYED;

            const formerOccupation = driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED ||
                driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.UNEMPLOYED;

            const nextState = {
                ...prevState,
                education: driver.education,
                employment: driver.employment,
                occupation: driver.occupation,
                hasBAverageOrHigher: driver.hasBAverageOrHigher,
                militaryBranch: driver.militaryBranch,
                militaryRank: driver.militaryRank,
                visibleOccupation: occupation || formerOccupation,
                visibleBAverageOrHigher: driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_HIGH_SCHOOL
                    || driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_TRADE_SCHOOL
                    || driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_UNDERGRADUATE
                    || driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_GRADUATE,
                visibleMilitaryBranch: visibleMilitary,
                visibleMilitaryRank: visibleMilitary,
                labelOccupation: formerOccupation ? LABELS.FORMER_OCCUPATION : LABELS.OCCUPATION,
                labelMilitaryBranch: driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY
                    ? LABELS.FORMER_MILITARY_BRANCH : LABELS.MILITARY_BRANCH,
                labelMilitaryRank: driver.employment === QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY
                    ? LABELS.FORMER_MILITARY_RANK : LABELS.MILITARY_RANK
            };

            nextProps.meta.propsSource = "";
            return nextState;
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                education: this.state.education,
                employment: this.state.employment,
                occupation: this.state.occupation,
                hasBAverageOrHigher: this.state.hasBAverageOrHigher,
                militaryBranch: this.state.militaryBranch,
                militaryRank: this.state.militaryRank
            };
            console.log(updatedDriver);
            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(PATHS.YOUR_HOME, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }
    
    callbackFunctionEmployment = (selectedValue: string) => {
        switch (selectedValue) {
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.OTHER:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.EMPLOYED:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.SELF_EMPLOYED:
                this.setState({
                    ...this.state,
                    employment : selectedValue,
                    labelOccupation: LABELS.OCCUPATION,
                    visibleOccupation: true,
                    visibleBAverageOrHigher: false,
                    visibleMilitaryBranch: false,
                    visibleMilitaryRank: false,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.UNEMPLOYED:
                this.setState({
                    ...this.state,
                    employment: selectedValue,
                    labelOccupation: LABELS.FORMER_OCCUPATION,
                    visibleOccupation: true,
                    visibleBAverageOrHigher: false,
                    visibleMilitaryBranch: false,
                    visibleMilitaryRank: false,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_HIGH_SCHOOL:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_TRADE_SCHOOL:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_UNDERGRADUATE:
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_GRADUATE:
                this.setState({
                    ...this.state,
                    employment: selectedValue,
                    visibleOccupation: false,
                    visibleBAverageOrHigher: true,
                    visibleMilitaryBranch: false,
                    visibleMilitaryRank: false,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.HOMEMAKER:
                this.setState({
                    ...this.state,
                    employment: selectedValue,
                    visibleOccupation: false,
                    visibleBAverageOrHigher: false,
                    visibleMilitaryBranch: false,
                    visibleMilitaryRank: false,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.MILITARY:
                this.setState({
                    ...this.state,
                    employment: selectedValue,
                    visibleOccupation: false,
                    visibleBAverageOrHigher: false,
                    labelMilitaryBranch: LABELS.MILITARY_BRANCH,
                    labelMilitaryRank: LABELS.MILITARY_RANK,
                    visibleMilitaryBranch: true,
                    visibleMilitaryRank: true,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
            case QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY:
                this.setState({
                    ...this.state,
                    employment: selectedValue,
                    visibleOccupation: false,
                    visibleBAverageOrHigher: false,
                    labelMilitaryBranch: LABELS.FORMER_MILITARY_BRANCH,
                    labelMilitaryRank: LABELS.FORMER_MILITARY_RANK,
                    visibleMilitaryBranch: true,
                    visibleMilitaryRank: true,
                    occupation: null,
                    militaryBranch: "",
                    militaryRank: ""
                });
                break;
        }
    };

    questionCallbackFunction(selectedValue: string, property: string) {
        const obj = {};
        obj[property] = selectedValue;
        this.setState({ ...this.state, ...obj });
    }

    handleOccupationSearch(query) {
        const driversApiClient = new DriversApiClient();
        return driversApiClient.getOccupations(query).then((response) => response.data);
    }

    onOccupationChange(selected: Array<ISuggestOption>) {
        if (!selected || 0 === selected.length) {
            this.setStateValue(null, "occupation");
            return;
        }

        this.setStateValue(selected[0], "occupation");
    }

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>{"EDUCATION & EMPLOYMENT"}</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <Question
                        name="education"
                        selectedValue={this.state.education}
                        selected={(v) => this.questionCallbackFunction(v, "education")}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "education")}
                        showItems={3}
                        items={[
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.HIGH_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.ASSOCIATE,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.BACHELORS,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.LESS_HIGH_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.VOCATIONAL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.MASTERS,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.MEDICAL_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.LAW_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EDUCATION.DOCTORATE
                        ]}
                        lable="What is the highest level of education you have completed?" />

                    <Question
                        name="employment"
                        selected={this.callbackFunctionEmployment}
                        selectedValue={this.state.employment}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "employment")}
                        showItems={3}
                        items={[
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.EMPLOYED,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.SELF_EMPLOYED,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_HIGH_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_TRADE_SCHOOL,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_UNDERGRADUATE,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.STUDENT_GRADUATE,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.UNEMPLOYED,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.OTHER,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.RETIRED_MILITARY,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.EMPLOYMENT.HOMEMAKER
                        ]}
                        lable="What's your current employment status?" />

                    <Form.Row style={{ display: this.state.visibleOccupation ? '' : 'none' }}>
                        <Form.Group as={Col}>
                            <Form.Label>{this.state.labelOccupation}</Form.Label>
                            <Suggest
                                id="basic-behaviors-example"
                                minLength={2}
                                placeholder="Enter occupation..."
                                onSearch={(q) => this.handleOccupationSearch(q)}
                                className={this.state.errors ? (validationUtils.hasValidationErrorFor(this.state.errors, "occupation") ? "is-invalid" : "is-valid") : ""}
                                onChange={(selected) => this.onOccupationChange(selected)}
                                defaultSelected={this.state.occupation ? [this.state.occupation] : null}
                            />
                            {this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "occupation")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.state.errors, "occupation")}
                                </Form.Control.Feedback>
                                : null
                            }
                        </Form.Group>
                    </Form.Row>

                    <Question
                        style={{ display: this.state.visibleBAverageOrHigher ? '' : 'none' }}
                        name="hasBAverageOrHigher"
                        selectedValue={this.state.hasBAverageOrHigher}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "hasBAverageOrHigher")}
                        selected={(v) => this.questionCallbackFunction(v, "hasBAverageOrHigher")}
                        items={[YES_NO.YES, YES_NO.NO]}
                        lable="Do you have B average or higher?" />

                    <Question
                        lable="Military Branch"
                        style={{ display: this.state.visibleMilitaryBranch ? '' : 'none' }}
                        name="militaryBranch"
                        selectedValue={this.state.militaryBranch}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "militaryBranch")}
                        selected={(v) => this.questionCallbackFunction(v, "militaryBranch")}
                        items={[
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.MILITARY_BRANCH.ARMY,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.MILITARY_BRANCH.NAVY,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.MILITARY_BRANCH.AIR_FORCE,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.MILITARY_BRANCH.MARINES,
                            QUOTE_QUESTIONS.EDUCATION_EMPLOYMENT.MILITARY_BRANCH.COAST_GUARD
                        ]} />

                    <Form.Row style={{ display: this.state.visibleMilitaryRank ? '' : 'none' }}>
                        <Form.Label>{this.state.labelMilitaryRank}</Form.Label>
                        <Form.Control as="select"
                            value={this.state.militaryRank}
                            onChange={(e) => { this.setStateValue(e.target.value, "militaryRank") }}>
                            <option value="">Select</option>
                            <option value="E-1 Private">E-1 Private</option>
                            <option value="E-2 Private">E-2 Private</option>
                            <option value="E-3 Private First Class">E-3 Private First Class</option>
                        </Form.Control>
                        {validationUtils.hasValidationErrorFor(this.state.errors, "militaryRank")
                            ? <Form.Control.Feedback type="invalid">
                                {validationUtils.getValidationErrorFor(this.state.errors, "militaryRank")}
                            </Form.Control.Feedback>
                            : null
                        }
                    </Form.Row>

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);
    
    return {
        quoteUid: state.quoteUid,
        driverIndex: driverIndex,
        driver: driverIndex < state.drivers.length ? state.drivers[driverIndex] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(QUOTE_STEPS.ABOUT_YOU)),
        updateAppState: (update) => dispatch(updateDriver(update.quoteUid, update.driver, QUOTE_STEPS.EDUCATION_EMPLOYMENT))
    };
};

export default connect(mapProps, mapDispatch)(EducationEmployment);
